/**
 * @typedef {{ strict?: boolean; onlyMobile?: boolean; }} ParsleyIntlPhoneNumberValidatorRequirement
 */

const currentLocale = mpro.getCurrentLocalesFor(mpro.getCurrentLocale(), 'parsleyjs')[0] || 'en';
const { Parsley } = window;

/**
 * @param {string} value
 * @param {import('intl-tel-input').Plugin} iti
 * @param {ParsleyIntlPhoneNumberValidatorRequirement} requirement
 */
const validate = (value, iti, requirement = {}) => {

	if (iti) {
		const {
			onlyMobile = false,
			strict = false,
		} = requirement || {};
		const { intlTelInputUtils } = window;
		/** @type {typeof intlTelInputUtils.numberType} */ // @ts-ignore
		const numberType = intlTelInputUtils.numberType || {};

		// If the country is not selected, we can't validate the phone number
		if (!iti.getSelectedCountryData()?.iso2) {
			return false;
		}

		if (onlyMobile && intlTelInputUtils) {

			const allowedNumberTypes = new Set([
				numberType.MOBILE,
				numberType.FIXED_LINE_OR_MOBILE,
			]);

			if (strict === false) {
				allowedNumberTypes.add(numberType.PERSONAL_NUMBER);
				// allowedNumberTypes.add(numberType.UNKNOWN);
			}

			if (allowedNumberTypes.has(iti.getNumberType()) === false) {
				return false;
			}
		}

		// Strict validation
		if (strict === true) {
			// @ts-ignore
			// if (iti.isValidNumber() === false) {
			// This idiot renamed isValidNumber to isValidNumberPrecise, because he's the only one using this library...
			// https://github.com/jackocnr/intl-tel-input/commit/78ec6a9dcb0a1425b5c8ecd4f4326130238ee7e5
			if (iti.isValidNumberPrecise() === false) {
				return false;
			}
		}

		// @ts-ignore
		// return iti.isPossibleNumber();
		// This idiot renamed isPossibleNumber to isValidNumber, because he's the only one using this library...
		// https://github.com/jackocnr/intl-tel-input/commit/78ec6a9dcb0a1425b5c8ecd4f4326130238ee7e5
		return iti.isValidNumber();
	}

	return true;
};

Parsley.addValidator('intlPhoneNumber', {

	requirementType: 'string',

	/**
	 * @param {string} value
	 * @param {string} requirement
	 */
	validateString: (value, requirement, parsleyInstance) => {

		const { $element } = parsleyInstance;
		/** @type {import('intl-tel-input').Plugin} */
		const iti = $element.data('iti');

		const validationResult = validate(value, iti, {
			strict: false,
			onlyMobile: false,
		});

		if (validationResult === false) {

			// Let parsley return the custom validator message
			if (Parsley.instanceHasCustomValidatorMessage(parsleyInstance, 'intlPhoneNumber')) {
				return false;
			}

			// Return the default message
			return false;
		}

		return true;
	},

	priority: 32,

	messages: {
		[currentLocale]: mpro.langvar('error_phone_number', { field_label: '' }).replaceAll(/\s+/g, ' '),
	},
});

Parsley.addValidator('intlPhoneNumberMobile', {

	requirementType: 'string',

	/**
	 * @param {string} value
	 * @param {string} requirement
	 */
	validateString: (value, requirement, parsleyInstance) => {

		const { $element } = parsleyInstance;
		/** @type {import('intl-tel-input').Plugin} */
		const iti = $element.data('iti');

		const validationResult = validate(value, iti, {
			strict: false,
			onlyMobile: true,
		});

		if (validationResult === false) {

			// Let parsley return the custom validator message
			if (Parsley.instanceHasCustomValidatorMessage(parsleyInstance, 'intlPhoneNumberMobile')) {
				return false;
			}

			// Return the default message
			return false;
		}

		return true;
	},

	priority: 32,

	messages: {
		[currentLocale]: mpro.langvar('error_phone_number', { field_label: '' }).replaceAll(/\s+/g, ' '),
	},
});

export {};